"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticTimeRangePicker = void 0;
const pickers_1 = require("@material-ui/pickers");
const shiftTZLocalToX_1 = __importDefault(require("@opsbase/lib-time/helpers/shiftTZLocalToX"));
const shiftTZXToLocal_1 = __importDefault(require("@opsbase/lib-time/helpers/shiftTZXToLocal"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const react_1 = __importStar(require("react"));
const makeDatePickerInput_1 = __importDefault(require("../helpers/makeDatePickerInput"));
const makePicker_1 = __importDefault(require("../helpers/makePicker"));
exports.StaticTimeRangePicker = (0, makePicker_1.default)((props) => {
    const { value, timezone, onChange, disabled } = props;
    const pickerValue = timezone ? value.map(v => (0, shiftTZXToLocal_1.default)(v, timezone)) : value;
    const handleChange = (0, react_1.useCallback)((v, type) => {
        let range = [];
        if (type === 'start') {
            range.push(timezone ? (0, shiftTZLocalToX_1.default)(v, timezone) : v);
            range.push(timezone ? (0, shiftTZLocalToX_1.default)(pickerValue[1], timezone) : pickerValue[1]);
        }
        else if (type === 'end') {
            range.push(timezone ? (0, shiftTZLocalToX_1.default)(pickerValue[0], timezone) : pickerValue[0]);
            range.push(timezone ? (0, shiftTZLocalToX_1.default)(v, timezone) : v);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(range);
    }, [onChange, timezone, pickerValue]);
    return (react_1.default.createElement(Vertical_1.default, { gutter: true, padding: true },
        react_1.default.createElement(pickers_1.TimePicker, { disabled: disabled, renderInput: (0, makeDatePickerInput_1.default)(pickerValue, props), label: "Start time", value: pickerValue[0], onChange: v => handleChange(v, 'start') }),
        react_1.default.createElement(pickers_1.TimePicker, { disabled: disabled, renderInput: (0, makeDatePickerInput_1.default)(pickerValue, props), label: "End time", value: pickerValue[1], onChange: v => handleChange(v, 'end') })));
});
exports.default = exports.StaticTimeRangePicker;
